// Copyright 2026. WebPros International GmbH. All rights reserved.

export const SET_FAILOVER_DOMAIN_LIST = 'failoverDomain/SET_FAILOVER_DOMAIN_LIST';
export const UPDATE_FAILOVER_DOMAIN_ITEM = 'failoverDomain/UPDATE_FAILOVER_DOMAIN_ITEM';
export const SET_FAILOVER_DOMAIN_ITEM_IS_LOADING = 'failoverDomain/SET_FAILOVER_DOMAIN_ITEM_IS_LOADING';
export const UNSET_FAILOVER_DOMAIN_ITEM_IS_LOADING = 'failoverDomain/UNSET_FAILOVER_DOMAIN_ITEM_IS_LOADING';
export const REMOVE_FAILOVER_DOMAIN_ITEM = 'failoverDomain/REMOVE_FAILOVER_DOMAIN_ITEM';
